<template>
  <section id="product" v-bind:class="'kind-' + acc.gender.toLowerCase()">
    <div class="container">
      <div class="row">
        <carousel :activePage="currentPage" @update="pageChanged" :navigationEnabled="false">
          <slide :key="color_index" v-for="(color,color_index) in acc.colors">
            <div class="product-big" v-bind:style="getPhoto(color,'big')"></div>
          </slide>
        </carousel>
        <div id="product-data">
          <div class="inner-positioner">
            <div id='sticker' v-if="isPromoted" v-html="sticker()"></div>

            <div class="features" v-if="features.length > 0">
              <ul class="features-logos">
                <li :key="index" v-for="(feature,index) in features">
                  <div :class="'feature-icon ' + feature.internal_name"></div>
                  <div class="desc">
                    <span v-html="feature.name"></span>
                  </div>
                </li>
              </ul>
              <!--<ul class="features-logos">-->
                <!--<bike-features :f="feature" :key="index" v-for="(feature,index) in features"></bike-features>-->
              <!--</ul>-->
            </div>
            <h1 class='model'>{{ acc.name }}</h1>
            <div v-if="acc.sell_price > 0 && language == 'pl' && !isPromoted" class="price"
                 v-html="$options.filters.full_price(acc.sell_price)">

            </div>
            <div class="price" v-if="language == 'pl' && isPromoted" v-html="promoPrice()">

            </div>

            <div v-translate="'available_colors'">Dostępne kolory</div>
            <ul class="color-switcher">
              <li :key="color_index"
                  v-for="(color,color_index) in acc.colors"
                  v-on:click="setActiveSlide(color_index)"
                  v-bind:class="{active: isCurrent(color_index)}">
                <div class="product-icon" v-bind:style="getPhoto(color,'icon')"></div>
                <p class="color-name">{{ color.color_name }}</p>
              </li>
            </ul>

            <div class="buttons-positioner">
              <div class="action-buttons" v-if="false && language == 'pl'">

                <div class="btn fat" href="#"
                     v-if="combinationSizes.length > 1"
                     v-on:click="toggleSizes()"
                     v-bind:class="{'active': sizesVisible}">
                  <div>{{ cartButtonLabel }}</div>
                  <ul>
                    <li :key="size.SKU" v-for="size in combinationSizes" v-bind:title="size.SKU">
                      <a v-on:click="addToCart(size.SKU, parseInt(size.stock))" :class="{'disabled' : parseInt(size.stock) === 0 }">{{ size.size }}</a>
                    </li>
                  </ul>
                </div>
                <a v-else class="btn fat" v-on:click="addToCart(combinationSizes[0].SKU, parseInt(combinationSizes[0].stock))" :class="{'disabled' : parseInt(combinationSizes[0].stock) === 0 }">{{ cartButtonLabel }}</a>
                <a class="btn fat" :href="getRoute('dealers')" v-translate="'find_dealer'">Znajdź dealera</a>

              </div>
              <div class="action-buttons" v-else>
                <a class="btn fat" :href="getRoute('dealers')" v-translate="'find_dealer'">Znajdź dealera</a>

              </div>
            </div>

          </div><!-- inner positioner -->
        </div><!-- acc data -->
      </div><!-- row -->
    </div><!-- container -->

    <v-dialog/>

  </section>
</template>

<script>

  import _ from 'lodash'
  import store from "./../../store/index"
  import Carousel from './../Carousel/Carousel'
  import Slide from './../Carousel/Slide'
  import BikeFeatures from '../Graphics/BikeFeatures.vue'

  export default {
    name: 'accessory',
    props: {
      model: String,
      color: String
    },
    components: {
      Carousel,
      Slide,
      BikeFeatures
    },
    computed: {

      curentColorId: function () {
        return this.slidesIndex[this.currentPage]
      },

      cartButtonLabel: function () {
        return this.sizesVisible ? translations['ct_pick_size'] : translations['ct_cart_add']
      },

      combinationSizes: function () {
        return _.filter(this.acc.combinations, {'main_color': this.curentColorId})
      },

    },

    created: function () {
      this.acc = _.find(window.env.data.accessories, {'internal_name': this.model});
      let that = this;
      let i = 0;

      _.forEach(that.acc.colors, function (el, key) {
        that.slidesIndex[i++] = key
      })
    },

    mounted() {

      let that = this;
      _.forEach(that.acc.colors, function (el, key) {


        if (el.main_color === that.color) {
          that.setActiveSlide(key);
          setTimeout(() => {
            that.$bus.$emit('colorChanged', key)
          }, 500);
        }
      });
      $.getJSON(env.baseUrl + 'data/features/' + this.acc.id, function (data) {
        that.features = data
      });
      if(typeof window.promoted !== 'undefined') {
				this.itempromoted = window.promoted.find(p => p.id === parseInt(that.acc.id));
			}
      this.isPromoted = (typeof this.itempromoted !== 'undefined');
    },

    data() {
      return {
      	isPromoted: false,
      	itempromoted: null,
        features: {},
        slidesIndex: [0],
        currentPage: 0,
        acc: {},
        sizesVisible: false,
        language: window.env.language

      }
    }, // data

    methods: {
			promoPrice()
			{
				if(typeof this.itempromoted.regular !== 'undefined' && typeof this.itempromoted.promo !== 'undefined')
				{
					return `<p class='price-regular'>${this.$options.filters.full_price(this.itempromoted.regular)}</p>` +
						`<p class='price-promo'>${this.$options.filters.full_price(this.acc.sell_price)}</p>` ;
				}
			},
			sticker()
			{
        if(!this.isPromoted) return  "";
				return `<div class="product-list-sticker black-friday"><div class="change">${this.itempromoted.change}</div></div>`;
			},

      getRoute(id) {
        let tid = 'rt_' + id;
        if(typeof window.translations[tid] !== 'undefined')
          return window.env.baseUrl + window.translations[tid];
        return "";
      },
      addToCart: function (sku,stock) {
        console.log(sku,stock);
        if(stock > 0) {

          let available = stock;
          if(typeof store.state.items != 'undefined') {
            let productInCart = store.state.items[sku];

            if (typeof productInCart != "undefined") {
              available -= productInCart.qty;
            }
          }

          if(available > 0) {
            this.$bus.$emit('addToCart', sku);
            console.log("event add to cart sent: " + sku);
          } else {
            this.modal('Uwaga','Przekroczono dostępną ilość produktu.');
          }
        } else {
          this.modal('Uwaga','Produkt aktualnie niedostępny.');
        }
      },

      toggleSizes: function () {
        this.sizesVisible = !this.sizesVisible
      },
      setActiveSlide: function (slideId) {
        this.currentPage = this.slidesIndex.indexOf(slideId)
      },

      pageChanged: function (page) {
        this.currentPage = page;
        this.$bus.$emit('colorChanged', this.slidesIndex[this.currentPage]);
      },

      isCurrent: function (slideId) {
        let slideIndex = this.slidesIndex.indexOf(slideId);
        return slideIndex === this.currentPage
      },

      getPhoto: function (color, style) {
        return 'background-image: url(\'' +
          env.baseUrl +
          'photos/styles/' + style + '/' +
          window.env.collection +
          '/accessories/legrand_' +
          color.photo_color.toLowerCase() + (color.is_glossy === '1' ? '_polysk' : '_mat') +
          '.png\');'
      },
      modal(title,message) {
        this.$modal.show('dialog', {
          title: title,
          text: message,
          buttons: [ {
            title: 'OK',
            default: true,
          },
          ]
        })
      }


    } // methods
  }
</script>



// WEBPACK FOOTER //
// src/components/Products/Accessory.vue